import httpService from "services/api.service";

export const getLocations = async (payload) => {
    try {
        const res = await httpService.get('/region', payload);
        return res;
    } catch (error) {
        throw error.response.data.msg;
    }
};